<template>
  <div class="box">
    <img class="activity-bg" src="../../../../static/banner.jpeg" alt="" />
    <!-- <img  class="banner-top" src="../../../../static/model-bg14.jpg" alt="" /> -->
    <div class="content-box">
      <div class="activity-content">
      <div  v-if="item.cardStatus==1"   v-for="(item,index) in materialParamsDTO.materialParamsDetailDTOList" :style="{'background-image':'url(../../../../static/month_bg'+(index+1)+'.png)','color':item.color}" :key="index" >
        <div class="main-icon" :style="{'color':item.color}">
          <span v-if="item.cardType==1">银卡</span>
          <span  v-if="item.cardType==2">金卡</span>
          <span  v-if="item.cardType==3">白金卡</span>
          <span  v-if="item.cardType==4">钻石卡</span>
        </div>
        <div class='content-main' :style="{'color':item.color}">
           <div class="top-content">
            <p>开通当日立得{{item.activationReceiveCoins}}书币</p>
            <p><span>￥{{item.rechargeMoney}}</span>
            <span>原价￥{{item.originalPrice}}</span></p>
           </div>
           <div class="bottom-content">
            <span>30天每日返送{{item.returnCoins}}书币</span>
            <p>共得<span style="color: #D73300;">{{item.totalbookCoin}}</span>书币</p>
           </div>
           <div class="bottom-btn" v-if="item.activationStatus==1"  >
            <p ><span>已开通</span><span>剩{{item.remainDay}}天</span> </p>
            <p  @click="getCurrency(item)" :style="{'color':'#FFFEF9','background-image':item.todayWhetherReceiveCoins==1?'url(../../../../static/month_centerbtn.png)':'url(../../../../static/month_default.png)'}">
              <span>{{item.todayWhetherReceiveCoins==1?'点击领取':'今日已领'}}</span>
              <span>{{item.receiveCoins}}书币</span></p>
            <p  :style="{'color':'#FFFEF9','background-image':status==2?'url(../../../../static/month_rightbtn.png)':'url(../../../../static/month_default.png)'}">
              <span v-if="status == 2" @click="goTopay(item)">点击续费</span>
            <span v-if="status == 1" class="default-btn">活动尚未开始</span>
            <span v-if="status == 0" class="default-btn">活动已下线</span>
            <span v-if="status == 3" class="default-btn">活动已结束</span>
            </p>
           </div>
           <div class="btn-content" @click="goTopay(item)"  v-if="item.activationStatus==2" :style="{'color':'#FFFEF9','background-image':status==2?'url(../../../../static/month_btn.png)':'url(../../../../static/default-line.png)'}" >
            <span v-if="status == 2" >立即开通</span>
            <span v-if="status == 1" class="default-btn">活动尚未开始</span>
            <span v-if="status == 0" class="default-btn">活动已下线</span>
            <span v-if="status == 3" class="default-btn">活动已结束</span>
          </div>
        </div>
      </div>
      <p class="open-swicth"><span>书币领取提醒</span>
      <img @click="updateCoinReceiveSwitches" :src="isopen==2?'../../../../static/switch-close.png':'../../../../static/switch-open.png'" alt=""></p>
      <div class="activity-tips">
        <p>- 活动规则 -</p>
        <p>1、购买月卡后30日内，每日登录书城即可弹窗手动领取书币；若关闭弹窗，可重新进入活动页领取书币并查看月卡状态；开通当日返送书币在充值后立即到账；</p>
        <p> 2、多种月卡可同时参与，开通当日赠送书币自动领取，返送书币累加金额进行返送；</p>
          <p>3、同种月卡支持续费，开通当日赠送书币自动领取，返送书币累加时间进行返送；</p>
          <p>4、每日返送书币限领一次，当日未领则过期作废，请及时领取。月卡返送有效期{{termOfValidity}}天，过期自动失效；</p>
          <p>5、书币领取提醒按钮开启后，每日若未领取当日书币会收到领取提醒消息；</p>
          <p>6、虚拟商品购买后不可退还，青少年请在家长陪同下充值；</p>
          <p> 7、活动最终解释权归当前网站所有，如有疑问请在公众号内联系客服。
        </p>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status", "materialParamsDTO", "termOfValidity",'switches','activityId'],
  data() {
    return {
      isopen:1
    };
  },
  watch: {
    materialParamsDTO: {
      handler: function (val) {
        console.log(val);
      },
      deep: true,
    }
  },
  mounted(){
    this.isopen=this.switches
      console.log(this.switches)

  },
  methods: {
    goTopay(item) {
      this.$emit("payActivity", item);
    },
    getCurrency(item){//领取
      if(item.todayWhetherReceiveCoins==2){
        return false;
      }
      this.$emit("payActivity", {data:1,item:item});
    },
    updateCoinReceiveSwitches(){
      if(this.isopen==1){
        this.isopen=2;
      }else{
        this.isopen=1
      }
      var params={
        switches:this.isopen,
        activityId:this.activityId
      }
      this.$api.updateCoinReceiveSwitches(params).then(res=>{

      })

    }
  },
};
</script>
<style scoped>
em {
  font-style: initial;
}
.box {
  position: relative;
}
.activity-bg {
  width: 100%;
  display: block;
  z-index:1;
  position: absolute;
  top:0px;
  left: 0px;
}
.banner-top{
  display:block;
  width:100%;
  position: absolute;
  top:0px;
  left: 0px;
}
.content-box{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(189px + env(safe-area-inset-top));
  z-index: 2;
  padding-bottom: 20px;
  width: 100%;
  background-image: linear-gradient(180deg, #fccf9e 0%, #fbb091 100%);
}
.activity-content {
  width:320px;
  margin:0 auto;
  margin-top:-23px;
}
.activity-content>div{
  margin-bottom:10px;
  position: relative;
  height: 181px;
  background-size: cover;
}
.main-icon{
  width: 42px;
height: 20px;
background-size: 100%;
background-repeat: no-repeat;
position: absolute;
left: 46px;
top: 11px;
font-size: 12px;
font-weight: 500;
line-height: 20px;
text-align: center;
font-weight: bold;
}


.top-content{
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding:0px 16px;
}
.top-content>p>span{
  display: block;
}
.top-content>p:nth-of-type(1){
  margin-top: 63px;
  line-height: 17px;
  font-weight: bold;
}
.top-content>p:nth-of-type(2){
  margin-top: 32px;;
  text-align: right;
}
.top-content>p>span:nth-of-type(2){
  text-decoration: line-through;
}
.top-content>p>span:nth-of-type(1){
  font-size: 20px;
  font-weight: bold;
}
.bottom-content{
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 9px;
  padding:0px 16px;
  line-height: 22px;
  font-weight: bold;
}
.bottom-content>span{
  /* width: 50%; */
}
.bottom-content>p{
  font-size: 18px;
  font-weight: 600;
  /* width: 50%; */
  text-align:right;
   
}
.btn-content{
  width: 310px;
height: 44px;
font-size: 18px;
text-align: center;
line-height: 44px;
position: absolute;
bottom:5px;
left:5px;
background-size: cover;
font-weight: 600;
}
.open-swicth{
  display: flex;
  color: #fff;
  justify-content: flex-end;
  font-size: 12px;
  height: 22px;
  line-height: 22px;
  margin-top:20px;
}
.open-swicth img{
  width:43px;
  height: 22px;
  margin-left: 8px;
 
}
.activity-content>div.activity-tips{
  padding:15px 14px;
  background-image: linear-gradient(180deg, #FCFEFF 0%, #FDF5E7 100%);
  font-size: 12px;
color: rgba(51,51,51,0.85);
margin-bottom: 0px;
line-height: 18px;
margin-top:20px;
height: auto;
}
.activity-tips>p:nth-of-type(1){
  font-size: 18px;
  text-align: center;
  margin-bottom:10px;
}
.bottom-btn{
  display: flex;
  position: absolute;
  width: 310px;
  justify-content: space-between;
bottom:5px;
left:5px;
font-weight: bold;
}
.bottom-btn>p>span{
  display: block;
}
.bottom-btn>p:nth-of-type(1){
  font-size: 12px;
  height: 44px;
  width: 54px;
  padding:6px 0px;
  box-sizing: border-box;
  text-align: center;
}
.bottom-btn>p:nth-of-type(1)>span{
  line-height: 17px;
}
.bottom-btn>p:nth-of-type(2){
  width: 128px;
height: 44px;
background-size: cover;
text-align: center;
font-size: 12px;
color: #FFFEF9;
line-height: 17px;
padding-top: 4px;
box-sizing: border-box;
}
.bottom-btn>p:nth-of-type(3){
  width: 128px;
height: 44px;
font-size: 16px;
color: #FFFEF9;
background-size: cover;
text-align: center;
line-height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modelfourteen.vue